<template>
   <div class="footer">本产品由来村网提供技术支持</div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props: {
    title: {
      type: String,
      default: () => {},
    }
  },
  setup(props) {

    onMounted(() => {
     
      
    });
    return {
      
    };
  },
};

</script>
<style lang="less" scoped>
    .footer{
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 50px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
</style>
